module.exports = "<div> <div class=facility-reporting-popover> <a href=\"{{ $ctrl.report.stats[month].reportUrl }}\" class=\"btn btn-primary\" target=_blank> Monthly Engagement </a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/facility-reporting/facility-reporting-popover/facility-reporting-popover.html
// module id = 386
// module chunks = 0